<template>
  <div class="howTo">
    <button
      class="close-button"
      :class="{ wind: !initialized }"
      @click="clickCloseButton"
    >
      使い方ガイドを閉じる
      <span class="close-icon"></span>
    </button>
    <div class="inner" @click="clickModal">
      <div class="modal" ref="modal">
        <div class="modal-inner">
          <picture>
            <source
              media="(max-width: 599px)"
              srcset="../../../assets/images/howoto_sp.png"
              width="724"
              height="956"
            />
            <img
              src="../../../assets/images/howto_pc.png"
              alt=""
              width="1528"
              height="1062"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HowTo",
  data() {
    return {
      initialized: false,
      timeoutId: null,
    };
  },
  methods: {
    clickModal(event) {
      const target = event.target;
      const modalContentIsClicked = target.closest(".modal") !== null;
      if (!modalContentIsClicked) {
        this.$emit("close");
      }
    },
    clickCloseButton() {
      this.$emit("close");
    },
    init() {
      this.initialized = true;
    },
  },
  mounted() {
    this.timeoutId = setTimeout(() => {
      this.init();
    }, 700);
  },
  beforeDestroy() {
    if (this.timeoutId) clearTimeout(this.timeoutId);
  },
};
</script>
<style lang="scss" scoped>
.howTo {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  .inner {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .close-button {
    font-size: 13px;
    color: $main-red;
    display: flex;
    align-items: center;
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 2;
    border: none;
    background-color: transparent;
    cursor: pointer;

    .close-icon {
      $size: 30px;
      width: $size;
      height: $size;
      display: block;
      background: url("../../../assets/images/_parts/other/close.svg") no-repeat
        center/contain;
      margin-left: 10px;
      transform: rotateZ(0);
      transition: transform 0.7s $easing-transition;
    }

    $rotate-deg: 360deg;
    &.wind {
      .close-icon {
        transform: rotateZ(-$rotate-deg);
      }
    }

    @media (hover: hover) {
      &:hover {
        .close-icon {
          transform: rotateZ($rotate-deg);
        }
      }
    }
  }

  .modal {
    position: relative;
    z-index: 3;
    width: 90%;
    max-width: 764px;
    padding: 0;
    margin: 0 auto;
  }

  .modal-inner {
    border: 1px solid #ddd;
  }

  @include media() {
    .inner {
    }

    .close-button {
      font-size: vw(12);
      display: flex;
      align-items: center;
      position: absolute;
      top: vw(20);
      right: vw(20);

      .close-icon {
        $size: vw(20);
        width: $size;
        height: $size;
        background: url("../../../assets/images/_parts/other/close.svg")
          no-repeat center/contain;
        margin-left: vw(8);
      }
    }

    .modal {
      max-width: auto;
    }
  }
}
</style>
